<template>
  <v-layout>
    <d-header
      fluid
      :actions="[
        {
          label: $t('save'),
          primary: true,
          color: 'is-primary',
          action: submitForm,
        },
      ]"
    >
      <h1 class="title">
        {{ $t("new_owner") }}
      </h1>
    </d-header>

    <div class="max-w-3xl">
      <v-form
        ref="form"
        action="create"
      />
    </div>
  </v-layout>
</template>

<script>
import form from "./_form.vue";
export default {
  metaInfo() {
    return {
      title: this.$t("new_owner"),
    };
  },
  components: {
    "v-form": form,
  },
  methods: {
    submitForm() {
      this.$refs.form.$refs.form.submit();
    },
  },
};
</script>
